import { get_axios_instance, api_variables, errorHandler,api_12bb_variables,get_axios_nest_instance } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMPLOYEE_PROFILE);
var axios_instance_it_dashboard = get_axios_instance(api_variables.SERVICE_EMPLOYEE_ITDASHBOARD);
var axios_instance_holiday_list = get_axios_instance(api_variables.SERVICE_HOLIDAYLIST);
var axios_instance_birthdays_list = get_axios_instance(api_variables.SERVICE_BIRTHDAYS_LIST);
var axios_instance_payroll_months = get_axios_instance(api_variables.SERVICE_EMPLOYEE_PAYROLL_MONTHS);
var axios_instance_compensation = get_axios_instance(api_variables.SERVICE_EMPLOYEE_COMPENSATION);
var axios_instance_payroll_months_for_it_sheet = get_axios_instance(api_variables.SERVICE_EMPLOYEE_PAYROLL_MONTHS_FOR_IT_SHEET)
var axios_instance_payroll_months_additional_payslip = get_axios_nest_instance(api_12bb_variables.SERVICE_EMPLOYEE_PAYROLL_MONTHS_ADDITIONAL_PAYSLIP)

const _pk_name = "id";

const state = {
    data: [],
    entityWiseData: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEditMode: (state, payload) => {
        //console.log("payload---", payload.record);
        state.editMode = payload.editMode;
        state.record = payload.record;
    },
    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
        //console.log('fetched exits', state.exits)
    },

    addEmployee: (state, payload) => {
        //console.log('payload data from store', payload)
        state.exits = payload;
        //console.log('exit data', state.exits);
        //console.log('state data', state.data);
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const updateTokenForHolidayList = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance_holiday_list.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const updateTokenForBirthDayList = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance_birthdays_list.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const updateTokenForPayrollMonths = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance_payroll_months.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const updateTokenForGet = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
  async fetchAll({commit}, payload) {
    try {
      updateTokenForGet()
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          ...payload
        }
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err){
        //console.log(err);
    }
  },

  async fetchItDashboardData({commit}, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_it_dashboard.post(`/`, {
          ...payload
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      // if(res.status == 200) {
      //   commit("set", res.data.data);
      // }
      return res;
    } catch (err){
        //console.log(err);
    }
  },

  async fetchHolidayList({commit}, payload) {
    try {
      // //console.log("In fetchAll start");
      updateTokenForHolidayList()
      commit("setFetching", true);
      let res = await axios_instance_holiday_list.get(`/`, {
        params: {
          ...payload
        }
      });
      // //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      // //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      // if(res.status == 200) {
      //   commit("set", res.data.data);
      // }
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },

  async fetchBirthdayList({commit}, payload) {
    try {
      updateTokenForBirthDayList()
      // //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_birthdays_list.get(`/`, {
        params: {
          ...payload
        }
      });
      // //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      // //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      // if(res.status == 200) {
      //   commit("set", res.data.data);
      // }
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },

  async fetchPayrollMonthList({commit}, payload) {
    try {
      updateTokenForPayrollMonths()
      // //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_payroll_months.get(`/`, {
        params: {
          ...payload
        }
      });
      // //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      // //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      // if(res.status == 200) {
      //   commit("set", res.data.data);
      // }
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },
  async fetchPayrollMonthListAdditionalPayslip({commit}, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_payroll_months_additional_payslip.get(`/`, {
        params: {
          ...payload
        }
      });
      commit("setFetching", false);
      commit("setFetching", false);
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },

  async fetchPayrollMonthListForITSheet({commit}, payload) {
    try {
      updateTokenForPayrollMonths()
      commit("setFetching", true);
      let res = await axios_instance_payroll_months_for_it_sheet.get(`/`, {
        params: {
          ...payload
        }
      });
      commit("setFetching", false);
      commit("setFetching", false);
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },

  async fetchEmployeeCompensation({commit}, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_compensation.get(`/`, {
        params: {
          ...payload
        }
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      // if(res.status == 200) {
      //   commit("set", res.data.data);
      // }
      return res;
    } catch (err){
        throw errorHandler(err.response);
    }
  },

}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
